import { Market } from "../../contracts";

export const getMarketId = (market: Market): string => {
    if(!market)
    {
        return "";
    }

    let a = market.id.match("^[1-3]_");
    if (a) {
        return market.id.slice(2, market.id.length);
    }
    return market.id;
}